import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sessionStorage as amplifySessionStorage } from 'aws-amplify/utils';

export const configureAuthSessionStorage = () => {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(amplifySessionStorage);
};
